import React from 'react';
import { Link } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';

interface NavbarProps {
  links: Array<any>;
}

export default function Navbar({ links = [] }: NavbarProps) {
  const [isOpen, setOpen] = React.useState(false);
  const toggle = () => setOpen(!isOpen);
  return (
    <nav className="w-full h-24 flex flex-row flex-wrap py-2 bg-white shadow-xl absolute top-0 left-0 z-30 md:justify-around md:shadow-none md:bg-transparent">
      <div className="h-auto w-64 flex px-4">
        <Link to="/" className="flex h-auto w-64 my-auto">
          <StaticImage
            alt="LOGO DE SVRID"
            src="../../images/logo-svrid.png"
            className="h-auto w-64 my-auto"
          />
        </Link>
      </div>
      <button
        type="button"
        className="md:hidden bg-transparent p-0 m-0 ml-auto my-auto outline-none mr-4"
        onClick={(e) => {
          e.preventDefault();
          toggle();
        }}
      >
        <div className="bg-blue-700 mb-2 p-0 rounded-full w-10 h-1" />
        <div className="bg-blue-700 mb-2 p-0 rounded-full w-10 h-1" />
        <div className="bg-blue-700 mb-2 p-0 rounded-full w-10 h-1" />
      </button>
      <ul
        className={`${
          isOpen ? 'block' : 'hidden'
        } bg-white w-full px-4 py-4 h-auto md:w-auto md:py-2 md:flex md:p-0 md:m-0 md:list-none md:flex-row md:flex-wrap md:h-12 md:shadow-xl md:rounded md:my-auto`}
      >
        {links.map((link) => (
          <li className="block py-2 md:flex md:p-0 md:px-3" key={link.path}>
            {link?.external ? (
              <a href={link.path} rel="noopener noreferrer" target="_blank" className="m-auto font-semibold text-lg text-gray-900 hover:text-blue-700">
                {link.title}
              </a>
            ) : (
              <Link
                className="m-auto font-semibold text-lg text-gray-900 hover:text-blue-700"
                to={link.path}
              >
                {link.title}
              </Link>
            )}
          </li>
        ))}
      </ul>
    </nav>
  );
}
